import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import TaskBudgetReducer from "../TaskBudget/TaskBudgetReducer.ts"; // Update the path as necessary

export const rootReducer = combineReducers({
  // IUnderstand: IUnderstandReducer,
  // Dashboard: DashboardReducer,
  // Conversation: ConversationReducer,
  // RightSidebar: RightSidebarReducer,
  // Sidebar: SidebarReducer,
  // Header: HeaderReducer,
  // ChatConversation: ChatConversationReducer,
  // Error: ErrorBoundaryReducer,

  TaskBudget: TaskBudgetReducer, 
});
export type RootState = ReturnType<typeof rootReducer>;

const store = configureStore({
  reducer: rootReducer,
});

export default store;